import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Endpoints, RestartResponseKeys } from '../../../api/Constants';
import { EVENT_TYPES } from '../../../lib/analytics/constants';
import Logger from '../../../lib/analytics/logger';
import { setAuthorized, setRestart, setToken } from '../../actions/auth';
import { handleQueryLoggerEvents } from '../../sagas/handleLoggerErrorEvents';
import utils from '../../../utils';
import gameVersion from '../../../utils/gameVersion';
import { clearActionCommands } from '../../slices/actionCommands/actionCommands';
var endpoint = Endpoints.RESTART_SESSION;
export var postRestartSessionMutation = {
  query: function query(data) {
    return {
      url: "".concat(endpoint),
      method: 'post',
      body: {
        data: _objectSpread(_objectSpread({}, data), {}, {
          platform: utils.getPlatform(),
          bundlever: gameVersion()
        })
      }
    };
  },
  transformResponse: function transformResponse(response) {
    return response;
  },
  onQueryStarted: function () {
    var _onQueryStarted = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(args, params) {
      var dispatch, queryFulfilled, _yield$queryFulfilled, data;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              dispatch = params.dispatch, queryFulfilled = params.queryFulfilled;
              _context.next = 4;
              return queryFulfilled;

            case 4:
              _yield$queryFulfilled = _context.sent;
              data = _yield$queryFulfilled.data;
              Logger.loginData = {
                type: 'persistent',
                email: data[RestartResponseKeys.EMAIL]
              };
              dispatch(setAuthorized(true));
              dispatch(setToken(data[RestartResponseKeys.AUTH_TOKEN]));
              dispatch(setRestart(data[RestartResponseKeys.RETURN_TOKEN]));
              dispatch(clearActionCommands());
              Logger.sendEvent(EVENT_TYPES.SUCCESFUL_LOGIN, {
                success: true
              });
              _context.next = 17;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](0);
              handleQueryLoggerEvents(_context.t0);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 14]]);
    }));

    function onQueryStarted(_x, _x2) {
      return _onQueryStarted.apply(this, arguments);
    }

    return onQueryStarted;
  }()
};